import React from 'react'
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import classNames from "classnames";

const CustomFormControl = (props:any) => {
  const useStyle = makeStyles(theme => ({
    root: {
      '& label': {
        color: '#242A38',
        fontSize: 14,
        fontWeight: 500,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'rgba(130, 145, 169, .5)',
        },
      },
    }
  }));
  const classes = useStyle();
  const formControlClasses = classNames(classes.root, props.className);
  return(
    <FormControl {...props} className={formControlClasses}>
      {props.children}
    </FormControl>
  );
}
export default CustomFormControl